module.exports = __webpack_public_path__ + "img/my-sub.397159fb.svg";